export const FullUserStringEnum = {
  team: 'Team',
  full: 'Full'
};
